import React from 'react'
import PropTypes from 'prop-types'

import './RichTextComponent.scss'

const RichTextComponent = ({ text }) => {
  return (
    /* oxlint-disable react/no-danger */
    <div
      className="rich-text-component"
      dangerouslySetInnerHTML={{ __html: text }}
    />
  )
}

RichTextComponent.propTypes = {
  text: PropTypes.string,
}

export default RichTextComponent
